module.exports = __webpack_public_path__ + "img/empreendimento-logo-16.fb627f53.png";